import React from "react";

export default function ToItem(props) {
  return (
    <div class="widget-chat-item right">
      <div class="widget-chat-info">
        <div class="widget-chat-info-container">
           <div class="widget-chat-message">{props.message}</div>
          <div class="widget-chat-time">6:00PM</div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Chat/ToItem.js